/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAdditionGroupListByCreateOrderRespVo } from './GetAdditionGroupListByCreateOrderRespVo';
import {
    GetAdditionGroupListByCreateOrderRespVoFromJSON,
    GetAdditionGroupListByCreateOrderRespVoFromJSONTyped,
    GetAdditionGroupListByCreateOrderRespVoToJSON,
    GetAdditionGroupListByCreateOrderRespVoToJSONTyped,
} from './GetAdditionGroupListByCreateOrderRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetAdditionGroupListByCreateOrderRespVo
 */
export interface ResponseListGetAdditionGroupListByCreateOrderRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetAdditionGroupListByCreateOrderRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetAdditionGroupListByCreateOrderRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetAdditionGroupListByCreateOrderRespVo>}
     * @memberof ResponseListGetAdditionGroupListByCreateOrderRespVo
     */
    data?: Array<GetAdditionGroupListByCreateOrderRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetAdditionGroupListByCreateOrderRespVo interface.
 */
export function instanceOfResponseListGetAdditionGroupListByCreateOrderRespVo(value: object): value is ResponseListGetAdditionGroupListByCreateOrderRespVo {
    return true;
}

export function ResponseListGetAdditionGroupListByCreateOrderRespVoFromJSON(json: any): ResponseListGetAdditionGroupListByCreateOrderRespVo {
    return ResponseListGetAdditionGroupListByCreateOrderRespVoFromJSONTyped(json, false);
}

export function ResponseListGetAdditionGroupListByCreateOrderRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetAdditionGroupListByCreateOrderRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetAdditionGroupListByCreateOrderRespVoFromJSON)),
    };
}

export function ResponseListGetAdditionGroupListByCreateOrderRespVoToJSON(json: any): ResponseListGetAdditionGroupListByCreateOrderRespVo {
    return ResponseListGetAdditionGroupListByCreateOrderRespVoToJSONTyped(json, false);
}

export function ResponseListGetAdditionGroupListByCreateOrderRespVoToJSONTyped(value?: ResponseListGetAdditionGroupListByCreateOrderRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetAdditionGroupListByCreateOrderRespVoToJSON)),
    };
}

